import * as React from 'react';
import { useCallback } from 'react';
import copyTextToBuffer from '../../../../services/mini/copyTextToBuffer';
import ToasterService from '../../../../services/ToasterService';

type EmbedCodeCopyButtonProps = {
    id: string,
    text: string,
    code: string,
    className: string

}
function EmbedCodeCopyButton({ id, text, code, className }: EmbedCodeCopyButtonProps) {
    const onClick = useCallback((str) => {
        copyTextToBuffer(str);
        ToasterService.showInfo({
            title: 'Copied to clipboard'
        });
    }, []);
    return <div className={`embed-code-copy-btn action-btn light-blue-with-border stage-prod-btn ${className && className}`}
        onClick={() => onClick(code)}>
        {text || 'Copy'}
    </div>;
}


export default EmbedCodeCopyButton;
